import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'

export const ProductFields = (dataSaldos, dataCliente) => {
  return [
    {
      label: 'Neto',
      class: 'textfield',
      value: dataSaldos.neto.toLocaleString('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      sm: 2,
      xs: 12,
      size: 'small',
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
    {
      label: 'IVA',
      class: 'textfield',
      value: dataSaldos.iva.toLocaleString('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      sm: 2,
      xs: 12,
      disabled: true,
      size: 'small',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
    {
      label: 'Total pedido',
      class: 'textfield',
      value: dataSaldos.total.toLocaleString('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      sm: 2,
      xs: 12,
      disabled: true,
      size: 'small',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
    {
      label: 'Saldo cliente',
      class: 'textfield',
      value: dataCliente?.saldo,
      sm: 3,
      xs: 4,
      disabled: true,
      size: 'small',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
    {
      label: 'Monto recibo',
      class: 'textfield',
      value: dataSaldos.montoRecibo,
      sm: 3,
      xs: 4,
      disabled: true,
      size: 'small',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
  ]
}
